<template>
	<div v-show="show">
		<vx-card>
			<vs-row v-if="skillUpdatePermission">
				<div class="vx-col w-full mb-base">
					<div>
						<SkillsForm :data="skillItem" :isEditActive="true" />
					</div>
				</div>
			</vs-row>
			<not-permission v-else></not-permission>
		</vx-card>
	</div>
</template>
<script>
import SkillsForm from "@/components/skills/SkillsForm.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	name: "Company",
	components: {
		SkillsForm,
		NotPermission,
	},
	data() {
		return {
			skillItem: {},
			show: false,
		};
	},
	computed: {
		skillUpdatePermission() {
			return this.$store.getters.checkPermission("SKILLS_U");
		},
	},
	mounted() {
		this.show = true;
	},
};
</script>
